const ColorPalette = [
  "#676490",
  "#f48368",
  "#fbc779",
  "#8eb6d1",
  "#8abc98",
  "#567a85",
  "#8768ad",
  "#9290b0",
  "#f7a693",
  "#fcd79f",
  "#aecbde",
  "#abcfb5",
  "#86a0a8",
  "#a99fc4",
];

export default ColorPalette;



// WEBPACK FOOTER //
// ./src/views/Project/RootCauseGraph/ColorPalette.js